import { useEffect } from 'react';

/**
 * Keep the <html> element's WebAwesome theme class in sync with the portal theme.
 * This enables WA component tokens (e.g. --wa-color-success-fill-quiet) to resolve
 * to the correct light/dark values, so anything derived from those tokens — including
 * our `Badge` component — adapts automatically.
 *
 * @param {string} theme The active portal theme ('light' or 'dark').
 */
export default (theme) => {
  useEffect(() => {
    const target = document.documentElement;
    target.classList.remove('wa-light', 'wa-dark');
    target.classList.add(`wa-${theme}`);
  }, [theme]);
};
